import React from 'react'
import ChangePasswordForm from '../../../features/Users/Component/changePassword/Component/ChangePassword';
import CardSection from '../../../components/ui/card/CardSection';

const ChangePassword = (props) => {
  return (

    <CardSection
      cardTitle="Change Password"
      buttonText="Confirm"
      buttonClassName="btn success-btn"
    >
      <ChangePasswordForm userId={props.userId} />
    </CardSection>

  )
}

export default ChangePassword;